import { render, staticRenderFns } from "./PrecificacaoList.vue?vue&type=template&id=c16266d2"
import script from "./PrecificacaoList.js?vue&type=script&lang=js&external"
export * from "./PrecificacaoList.js?vue&type=script&lang=js&external"
import style0 from "./PrecificacaoList.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports